import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, Validators, FormControl, FormGroup, } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { EtlState, errorTypes } from '@etl/etl.reducer';
import * as EtlActions from '@etl/etl.actions';
import * as etlSelectors from '@etl/etl.selectors';
import { FormControlService } from '@base/form-controls.service';
import { EMPTY } from '@base/utils';
import * as fromModels from '@models';

@Component({
  selector: 'app-dialog-etl',
  templateUrl: './dialog-etl.component.html',
  styleUrls: ['./dialog-etl.component.sass']
})
export class DialogEtlComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[];
  private _edit = false;
  private _etl: fromModels.Etl;

  id = new FormControl(null, );
  name = new FormControl(null, [Validators.required, Validators.maxLength(45)]);
  path_job = new FormControl(null, [Validators.required, Validators.maxLength(255)]);
  company = new FormControl(null, [Validators.required]);
  etlForm: FormGroup;
  isPending: Observable<boolean>;
  etlAdded: Subscription;
  etlUpdated: Subscription;
  instance: Subscription;
  showSpinner = false;

  constructor(
    private store: Store<{etls: EtlState}>,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogEtlComponent>,
    private formControlService: FormControlService,
    @Inject(MAT_DIALOG_DATA) public info: object
  ) {
    this.subscriptions = [];
    this.etlForm = this.fb.group({
      id: this.id,
      name: this.name,
      path_job: this.path_job,
      company: this.company,
    });
  }

  ngOnInit() {
    const added = this.store.select(etlSelectors.successfullyAdded).subscribe(
      ({successfullyAdded, }) => {
        if (successfullyAdded) {
          this.sendResponse(null);
        }
      }
    );

    const edited = this.store.select(etlSelectors.successfullyEdited).subscribe(
      ({successfullyEdited, }) => {
        if (successfullyEdited) {
          this.sendResponse(null);
        }
      }
    );

    const errorSubs = this.store.select(etlSelectors.getError).subscribe(
      ({error, errorType}) => {
        console.log(errorType);
        const isAllowedActions = (errorType === errorTypes.creating || errorType === errorTypes.editing);

        if (error !== null && isAllowedActions) {
          this.openSnackBar(error.message, error.name);
        }
      }
    );

    this.instance = this.store.select(etlSelectors.getRow).subscribe(
      (etl: fromModels.Etl) => {
        this._etl = etl;
        this.etlForm.patchValue({
          id: this._etl.id,
          name: this._etl.name,
          path_job: this._etl.path_job,
          company: this._etl.company,
        });
        this._edit = (this._etl.id !== null);
      }
    );

    this.subscriptions = [...this.subscriptions, added, errorSubs, edited,
      this.instance];
  }

  ngOnDestroy() {
    this.subscriptions.map((subscription) => subscription.unsubscribe());
  }

  onSubmit() {
    let etl: fromModels.Etl = new fromModels.Etl();
    etl = this.etlForm.value;
    const payload = {row: etl};

    if (etl.company !== EMPTY) {
      if (!this._edit) {
        this.store.dispatch(EtlActions.create(payload));
      } else {
        const editPayload = Object.assign(
          {}, etl, {company: etl.company['id']}
        );
        this.store.dispatch(EtlActions.update({row: editPayload}));
      }
    }
  }

  sendResponse(etl: fromModels.Etl) {
    this.openSnackBar('Los cambios han sido registrados', 'info');
    this.etlForm.reset();
    this.dialogRef.close(etl);
  }

  getErrorMessage(control: FormControl) {
    const strError = this.formControlService.checkErrorInControl(control);
    return strError;
  }

  private openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 4000,
    });
  }
}
